"use client";

import * as React from "react";
import { Phone, ShieldCheck, MapPin, Clock, Zap, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { FormProvider } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
const trustBadges = [{
  icon: ShieldCheck,
  label: "Veteran Owned"
}, {
  icon: MapPin,
  label: "Locally Owned"
}, {
  icon: Clock,
  label: "24/7 Emergency"
}, {
  icon: Zap,
  label: "Same Day Service"
}];
export default function RequestAQuote() {
  return <section id="request-a-quote" className="py-20 px-6 overflow-hidden !bg-[hsl(0,0%,96%)] sm:px-8">
      <div className="mx-auto max-w-4xl flex flex-col items-center text-center space-y-10 animate-in fade-in slide-in-from-bottom-6 duration-1000 fill-mode-both">
        <h2 className="text-4xl font-bold uppercase tracking-tighter leading-none !text-[hsl(0,0%,0%)] !font-sans md:text-5xl">DON'T SEE YOUR AREA?
CONTACT US ANYWAY!</h2>
        
        <div className="flex flex-col items-center gap-8 w-full">
          <Dialog>
            <DialogTrigger asChild>
              {}
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-4 py-2 font-medium transition-all duration-300">
                Get A Free Quote
              </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[550px]">
              <DialogHeader>
                <DialogTitle className="text-3xl font-serif font-bold text-foreground uppercase tracking-tight">
                  Request a Quote
                </DialogTitle>
                <DialogDescription className="text-base text-muted-foreground flex flex-col gap-2 mt-2">
                  
                  <span className="flex items-center gap-2 font-semibold text-foreground mt-2 bg-accent/50 p-2 rounded-md justify-center sm:justify-start">
                    <Phone className="size-4 text-primary" />
                    Need immediate assistance? 
                    <Link to="tel:7133044798" className="text-primary hover:underline">
                      Call 713-304-4798
                    </Link>
                  </span>
                </DialogDescription>
              </DialogHeader>
              
              <FormProvider formId="request-quote-form" fields={[{
              id: "name",
              type: "text",
              label: "Full Name",
              placeholder: "John Doe",
              required: true
            }, {
              id: "email",
              type: "email",
              label: "Email Address",
              placeholder: "john@example.com",
              required: true
            }, {
              id: "phone",
              type: "tel",
              label: "Phone Number",
              placeholder: "(713) 555-0123",
              required: true
            }, {
              id: "service_type",
              type: "select",
              label: "Service Type",
              placeholder: "Select a service",
              required: true,
              options: [{
                label: "Garage Door Repair",
                value: "repair"
              }, {
                label: "Garage Door Installation",
                value: "installation"
              }, {
                label: "Commercial Services",
                value: "commercial"
              }, {
                label: "Residential Services",
                value: "residential"
              }, {
                label: "Emergency Service",
                value: "emergency"
              }, {
                label: "Other",
                value: "other"
              }]
            }, {
              id: "images",
              type: "file",
              label: "Upload Photos (Optional)",
              placeholder: "Share photos of your garage door issue",
              required: false
            }, {
              id: "message",
              type: "textarea",
              label: "How can we help?",
              placeholder: "Please describe your garage door issue or project...",
              required: true
            }]} submitButtonText="Send Request" submitButtonClassName="w-full mt-4 h-12 text-base font-bold uppercase tracking-widest" />
            </DialogContent>
          </Dialog>

          {}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full max-w-3xl pt-4">
            {trustBadges.map((badge, i) => <div key={badge.label} data-index={i} className="flex flex-col items-center gap-2 p-4 rounded-xl border border-white/20 backdrop-blur-sm transition-colors !bg-[hsl(137,66%,31%)] hover:bg-white/15">
                <badge.icon className="size-6 text-primary-foreground/90" />
                <span className="text-[10px] sm:text-xs font-bold text-primary-foreground uppercase tracking-widest text-center">
                  {badge.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}